import React, { useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Play } from "lucide-react";

export function LaunchVideoDialog({ open, onOpenChange }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) v.play();
    else v.pause();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[360px] p-0 border-0 bg-transparent shadow-none" data-testid="launch-video-dialog">
        <DialogTitle className="sr-only">Video FYDATE</DialogTitle>
        <div
          className="relative rounded-[24px] overflow-hidden bg-black shadow-2xl cursor-pointer select-none"
          onClick={toggle}
          data-testid="launch-video-frame"
        >
          <video
            ref={ref}
            data-testid="launch-video"
            src="/launch-video.mp4"
            playsInline
            preload="metadata"
            className="w-full max-h-[78vh] block"
            onPlay={() => setPlaying(true)}
            onPause={() => setPlaying(false)}
            onEnded={() => setPlaying(false)}
            onTimeUpdate={(e) => {
              const v = e.target;
              setProgress(v.duration ? (v.currentTime / v.duration) * 100 : 0);
            }}
          />
          {!playing && (
            <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-t from-black/30 to-black/5 transition-opacity">
              <div className="w-[70px] h-[70px] rounded-full bg-white/95 flex items-center justify-center shadow-xl">
                <Play size={28} className="text-[#0F1230] ml-1" fill="#0F1230" />
              </div>
            </div>
          )}
          <div className="absolute left-0 bottom-0 h-1 w-full bg-white/20">
            <div className="h-full bg-[#FFD23F] transition-[width] duration-150" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
